import { render, staticRenderFns } from "./AlarmList.vue?vue&type=template&id=66f349a0&scoped=true"
import script from "./AlarmList.vue?vue&type=script&lang=js"
export * from "./AlarmList.vue?vue&type=script&lang=js"
import style0 from "./AlarmList.vue?vue&type=style&index=0&id=66f349a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f349a0",
  null
  
)

export default component.exports